<template>
  <div>
    <v-card flat>
      <v-card-text class="pt-0">
        <fieldset class="srs_fset">
          <legend class="srs_lgd">{{ $t('page.series.expansion-panel.series-details') }}</legend>
          <div class="clearfix">
            <v-form class="filtersSeries">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="serieName"
                    :label="$t('page.series.inputlbl-series-name')"
                    outlined dense
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    v-model="displaySerieOnline"
                    :items="displaySerieOnlineItems"
                    :label="$t('page.series.inputlbl-display-series-online')"
                    item-text="text"
                    item-value="id"
                    outlined dense
                    :no-data-text="$t('common.no_data')"
                  ></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    v-model="seriesType"
                    :items="seriesTypeItems"
                    :label="tWithFallback('page.series.inputlbl-series-type', 'Series Type')"
                    item-text="text"
                    item-value="value"
                    outlined dense
                  ></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    v-model="tiebreakMethod"
                    :items="tiebreakMethodItems"
                    :label="$tc('page.series.inputlbl-tiebreak-method')"
                    outlined dense
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="dateFrom"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateFrom"
                        :label="$tc('page.series.inputlbl-date-from')"
                        outlined dense
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker 
                      v-model="dateFrom" 
                      no-title 
                      scrollable
                      :header-date-format="$datePicker.formatDateHeader"
                      :title-date-format="$datePicker.formatTitleDate"
                      :weekday-format="$datePicker.formatWeekday"
                      :month-format="$datePicker.formatMonth"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">{{$t('common.cancel')}}</v-btn>
                      <v-btn text color="primary" @click="$refs.menu.save(dateFrom)">{{$t('common.save')}}</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="dateTo"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateTo"
                        :label="$t('page.series.inputlbl-date-to')"
                        outlined dense
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker 
                        v-model="dateTo" 
                      no-title 
                      scrollable
                      :header-date-format="$datePicker.formatDateHeader"
                      :title-date-format="$datePicker.formatTitleDate"
                      :weekday-format="$datePicker.formatWeekday"
                      :month-format="$datePicker.formatMonth"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu2 = false">{{$t('common.cancel')}}</v-btn>
                      <v-btn text color="primary" @click="$refs.menu2.save(dateTo)">{{ $t("common.save") }}</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12">
                  <v-card-text class="pa-0">
                    <fieldset class="srs_fset">
                        <legend class="srs_lgd">{{$t('page.series.series_options')}}</legend>
                        <v-row>
                          <v-col cols="12" md="3" sm="6" class="mx-3">
                            <v-checkbox
                              v-model="showOverallPoints"
                              :label="$t('page.series.show_overall_points')"
                            ></v-checkbox>
                            <v-checkbox
                              v-model="showClassPoints"
                              :label="$t('page.series.show_class_points')"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="3" sm="6" class="mx-3">
                            <v-checkbox
                              v-model="showGroupPoints"
                              :label="$t('page.series.show_group_points')"
                            ></v-checkbox>
                            <v-checkbox
                              v-model="showAwards"
                              :label="$t('page.series.show_awards')"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="3" sm="6" class="mx-3">
                            <v-checkbox
                              v-model="showBrand"
                              :label="$t('page.series.show_brands')"
                            ></v-checkbox>
                            <v-checkbox
                              v-model="showDropTotal"
                              :label="$t('page.series.show_drops')"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                    </fieldset>
                  </v-card-text>
                </v-col>

                <v-col cols="12" sm="12" md="6" class="text-left mb-2">
                  <v-btn class="ma-2" color="primary" @click="saveDetails()">{{ $t('common.save') }}</v-btn>
                </v-col>

              </v-row>
            </v-form>

            <v-expansion-panels v-model="panel">

              <v-expansion-panel>
                <v-expansion-panel-header color="lighten" @click.native="loadComponentData('seriesRaceTblRef')">
                  {{ this.$t("page.series.expansion-panel.races") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <br>
                  <SeriesRaceTbl ref="seriesRaceTblRef" @refreshRaces="(params) => $emit('refreshRaces',params)"/>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header color="lighten" @click.native="loadComponentData('seriesRaceColumnTblRef')">
                  {{ this.$t("page.series.expansion-panel.race-column-label") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <SeriesRaceColumnTbl ref="seriesRaceColumnTblRef" />
                </v-expansion-panel-content>
              </v-expansion-panel>
              
              <v-expansion-panel>
                <v-expansion-panel-header @click.native="loadComponentData('seriesBrandsTblRef')">{{ this.$t("page.series.expansion-panel.brands") }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <br>
                  <SeriesBrandsTbl ref="seriesBrandsTblRef"/>
                </v-expansion-panel-content>
              </v-expansion-panel>
              
              <v-expansion-panel>
                <v-expansion-panel-header @click.native="loadComponentData('seriesGroupsTblRef')">{{ this.$t("page.series.expansion-panel.groups") }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <br>
                  <SeriesGroupsTbl ref="seriesGroupsTblRef" />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header @click.native="loadComponentData('seriesGroupOptionRef')">{{ this.$t("page.series.expansion-panel.group-option") }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <br>
                  <SeriesGroupOption ref="seriesGroupOptionRef" />
                </v-expansion-panel-content>
              </v-expansion-panel>
              
              <v-expansion-panel>
                <v-expansion-panel-header @click.native="loadComponentData('seriesClassTblRef')">{{ this.$t("page.series.expansion-panel.classes") }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <br>
                  <SeriesClassTbl ref="seriesClassTblRef" />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header @click.native="loadComponentData('seriesClassOptionRef')">{{ this.$t("page.series.expansion-panel.class-option") }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <br>
                  <SeriesClassOption ref="seriesClassOptionRef" />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header @click.native="loadComponentData('seriesAwardsTblRef')">{{ this.$t("page.series.expansion-panel.awards") }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <br>
                  <SeriesAwardsTbl ref="seriesAwardsTblRef" />
                </v-expansion-panel-content>
              </v-expansion-panel>
              
              <v-expansion-panel>
                <v-expansion-panel-header @click.native="loadComponentData('seriesPointsScheaduleTblRef')">{{ this.$t("page.series.expansion-panel.points-schedule") }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <br>
                  <SeriesPointsScheaduleTbl ref="seriesPointsScheaduleTblRef"/>
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
          </div>
        </fieldset>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" timeout="3000" :color="color_snackbar">
      {{ msg_snackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          <v-icon>fas fa-times-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SeriesRaceTbl from "@/components/series/tables/SeriesRaceTbl.vue";
import SeriesRaceColumnTbl from "@/components/series/tables/SeriesRaceColumnTbl.vue";
import SeriesGroupsTbl from "@/components/series/tables/SeriesGroupsTbl.vue";
import SeriesBrandsTbl from "@/components/series/tables/SeriesBrandsTbl.vue";
import SeriesClassTbl from "@/components/series/tables/SeriesClassTbl.vue";
import SeriesPointsScheaduleTbl from "@/components/series/tables/SeriesPointsScheaduleTbl.vue";
import SeriesGroupOption from "@/components/series/tables/SeriesGroupOption.vue";
import SeriesClassOption from "@/components/series/tables/SeriesClassOption.vue";
import SeriesAwardsTbl from "@/components/series/tables/SeriesAwardsTbl.vue";
import { mapState } from "vuex";
import { isNaN } from "lodash";
import { YES_NO_OPTIONS } from "@/constants/selectOptions.js";

export default {
  mixins: [apiCalls],
  components: { 
    SeriesRaceTbl,
    SeriesGroupsTbl,
    SeriesBrandsTbl,
    SeriesClassTbl,
    SeriesGroupOption,
    SeriesClassOption,
    SeriesPointsScheaduleTbl,
    SeriesAwardsTbl,
    SeriesRaceColumnTbl
  },
  data() {
    return {
      eventSelected: null,
      eventItems: [],
      tab: null,
      items: [
        { tab: "Series Details", content: "Tab 1 Content" },
        { tab: "Series Results", content: "Tab 2 Content" }
      ],
      serieName: null,
      displaySerieOnline: null,
      dateFrom: null,
      dateTo: null,
      menu: false,
      menu2: false,
      modal: false,
      checkbox: false,
      showOverallPoints: false,
      showClassPoints: false,
      showGroupPoints: false,
      showBrand: false,
      showAwards: false,
      snackbar: false,
      msg_snackbar: '',
      color_snackbar: 'error',
      panel: [],
      showDropTotal: false,
      seriesType: null,
      tiebreakMethod: null
    };
  },
  watch: {
    seriesSelected() {
      this.panel = [];
      this.load();
    },
  },
  methods: {
    tWithFallback(key, fallbackText){
      const translated = this.$t(key);
      return translated === key ? fallbackText : translated;
    },
    loadComponentData(ref)
    {
      if(isNaN(parseInt(this.panel)))
      {
        return;
      }

      this.$refs[ref].init()
    },
    load(){
      if(this.seriesSelected) {
        this.serieName = this.seriesSelected.seriesName;
        this.displaySerieOnline = null;

        this.displaySerieOnlineItems.forEach(element => {
          if (element.id == this.seriesSelected.isVisibleToPublic) {
            this.displaySerieOnline = element.id;
          }
        });
        
        this.dateFrom = this.seriesSelected.dateFrom;
        this.dateTo = this.seriesSelected.dateTo;
        this.showOverallPoints = this.seriesSelected.showOverall;
        this.showClassPoints = this.seriesSelected.showClass;
        this.showGroupPoints = this.seriesSelected.showGroup;
        this.showAwards = this.seriesSelected.showAwards;
        this.showBrand = this.seriesSelected.showBrand;
        this.showDropTotal = this.seriesSelected.showTotals;
        this.seriesType = this.seriesSelected.seriesType;
        this.tiebreakMethod = this.seriesSelected.tiebreakMethod;
      }
    },
    async saveDetails(){
      let data = {
        seriesId: this.seriesSelected.id,
        seriesName: this.serieName,
        isVisibleToPublic: this.displaySerieOnline,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        showOverall: this.showOverallPoints,
        showClass: this.showClassPoints,
        showGroup: this.showGroupPoints,
        showAwards: this.showAwards,
        showBrand: this.showBrand,
        showTotals: this.showDropTotal,
        seriesType: this.seriesType,
        tiebreakMethod: this.tiebreakMethod
      };


      //TODO: set the url
      const url = '/api/v1/promoter/series/update';
      const response = await this.api('put', url, data);
      if(response && !response.success){
        //TODO: alert the user the record was saved
        this.snackbar = true;
        this.msg_snackbar = this.$t('page.series.' + response.message);
        this.color_snackbar = 'error';
      } else if(!response) {
        this.snackbar = true;
        this.msg_snackbar = this.$t('page.series.error_general');
        this.color_snackbar = 'error';
      }
      this.$emit('loadEvent', this.seriesSelected.id);
    },
    async updateSeries(index, value){
      let data = {};
      data[index] = value;  
      data.seriesId = this.seriesSelected.id;

      const response = await this.api("PUT", "/api/v1/promoter/series/update", data);
      
      if(response != undefined){
        if(response.error != undefined){
          for( var i = 0; i < response.error.length; i++){
            const errorMessage = response.error[i];
            this.alertMessage = this.$t(`common.request.${errorMessage}`)
            this.dialogAlert = true;
          }
          return false;
        }else{
          try{
            if(response.message == 1){
              this.seriesSelected.showOverall = value
            }
          } catch {/*---*/}
        }
      }
    },
  },
  computed: {
    ...mapState({
      seriesSelected: state => state.series.seriesSelected
    }),
    seriesTypeItems() {
      return [
        {
          text: this.tWithFallback("page.series.series-type-items.final", "Final"),
          value: "final"
        },
        {
          text: this.tWithFallback("page.series.series-type-items.overall", "Overall"),
          value: "overall"
        },
        {
          text: this.tWithFallback("page.series.series-type-items.standalone", "Standalone"),
          value: "standalone"
        }
      ];
    },
    tiebreakMethodItems() {
      return [
        { text: this.$t("page.series.tiebreak-method.last-race"), value: "LastRace" },
        { text: this.$t("page.series.tiebreak-method.none"), value: "None" }
      ];
    },
    displaySerieOnlineItems() { return YES_NO_OPTIONS(this); }
  },
  created() {
    const d = new Date();
    const curYear = d.getFullYear();

    this.dateFrom = `${curYear}-01-01`;
    this.dateTo = `${curYear}-12-31`;
  }, 
  mounted(){
    this.panel = [];
    this.load();
  }
};
</script>

<style scoped>

.orlbl {
  font-weight: bold;
  font-size: 14px;
  margin-right: 20px;
}

.newseriesbtn {
  margin-top: 0px !important;
}

.srs_fset {
  padding: 0.35em 0.625em 0.75em !important;
  margin: 5px !important;
  border: 1px solid var(--v-lighten-base) !important;
}

.srs_lgd {
  width: auto !important;
  font-size: 15px !important;
  border-bottom: none !important;
  margin-bottom: 0px !important;
}

.customlink {
  color: var(--v-primary-lighten1);
  font-weight: bold;
  text-decoration: underline;
}

.tabscard {
  margin: 10px 5px;
}

.v-tab {
  text-transform: initial;
}
</style>

<style>
.inputSeries .v-text-field__details{
  margin-bottom: 0px !important;
  min-height: 0px;
}
.inputSeries .v-text-field__details .v-messages{
  min-height: 0px;
  height: auto;
}
</style>